import React from 'react';
import styles from './Enquiries.module.css';

const EnquiriesEmptyState = ({ onCreateEnquiry, activeFilter }) => {
  const getEmptyMessage = () => {
    switch (activeFilter) {
      case 'new':
        return {
          title: 'No new enquiries',
          description: 'New customer enquiries will appear here when they contact you.'
        };
      case 'conversation':
        return {
          title: 'No active conversations',
          description: 'Enquiries you\'re actively discussing with customers will appear here.'
        };
      case 'archived':
        return {
          title: 'No archived enquiries',
          description: 'Completed or closed enquiries will appear here.'
        };
      default:
        return {
          title: 'No enquiries yet',
          description: 'Customer enquiries will appear here when they contact you. Start by creating your first enquiry.'
        };
    }
  };

  const message = getEmptyMessage();

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContent}>
        <svg 
          className={styles.emptyStateIcon}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1.5}
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
          />
        </svg>
        <h3 className={styles.emptyStateTitle}>{message.title}</h3>
        <p className={styles.emptyStateDescription}>
          {message.description}
        </p>
        {activeFilter === 'all' && (
          <button
            onClick={onCreateEnquiry}
            className={styles.emptyStateButton}
          >
            Create Your First Enquiry
          </button>
        )}
      </div>
    </div>
  );
};

export default EnquiriesEmptyState;